module.exports = __webpack_public_path__ + "static/colaboradores-02-3b0c5b2417765acdba80669eef28f9da.png";